import { z } from "zod";

export const CONTACT_PROJECT_TYPES = ["entretien", "tailles", "amenagements", "autre"] as const;
export type ContactProjectType = (typeof CONTACT_PROJECT_TYPES)[number];

export const CONTACT_MESSAGE_MAX = 500;

// Téléphones FR (mobile + fixe + indicatif international). On reste tolérant aux
// espaces/points/tirets que les visiteurs saisissent naturellement.
const FR_PHONE_REGEX = /^(?:(?:\+|00)33[\s.-]?|0)[1-9](?:[\s.-]?\d{2}){4}$/;

export const contactFormSchema = z.object({
  nom: z
    .string()
    .trim()
    .min(2, "Nom : au moins 2 caractères")
    .max(80, "Nom : maximum 80 caractères"),
  email: z.string().trim().toLowerCase().email("Email invalide").max(200, "Email trop long"),
  telephone: z
    .string()
    .trim()
    .max(30, "Téléphone trop long")
    .refine((v) => v === "" || FR_PHONE_REGEX.test(v), "Numéro de téléphone invalide")
    .optional()
    .transform((v) => (v && v.length > 0 ? v : undefined)),
  projectType: z.enum(CONTACT_PROJECT_TYPES),
  message: z
    .string()
    .trim()
    .min(10, "Message : au moins 10 caractères")
    .max(CONTACT_MESSAGE_MAX, `Message : maximum ${CONTACT_MESSAGE_MAX} caractères`),
  // Honeypot : champ caché qui doit rester vide. Les bots remplissent tout.
  // Si renseigné, on rejette silencieusement (200 OK côté handler pour ne pas
  // donner d'indice au bot).
  website: z.string().max(0, "honeypot").optional().default(""),
});

export type ContactFormInput = z.input<typeof contactFormSchema>;
export type ContactFormValues = z.output<typeof contactFormSchema>;

export const CONTACT_PROJECT_LABELS: Record<ContactProjectType, string> = {
  entretien: "Entretien",
  tailles: "Tailles spécifiques",
  amenagements: "Aménagement extérieur",
  autre: "Autre",
};
